import ReactDOM from 'react-dom/client';
import React from 'react';
import { v2Component } from '../../../index';
import { TenantContext } from '../../../context/tenant-context';
import { OrderStatusTransitionPaymentRequirementConfig } from './order-status-transition-payment-requirement-config';
import { ToastContainer } from 'react-toastify';

export function initOrderStatusTransitionPaymentRequirementConfig(element?: HTMLElement) {
  const elements =
    element !== undefined
      ? [element]
      : document.getElementsByName('order-status-transition-payment-requirement-config');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <OrderStatusTransitionPaymentRequirementConfig {...props} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
